import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import { SessionProvider } from './auth/session.tsx';
import { router } from './router.tsx';

// Server state through TanStack Query, and no global client store for it (CB-CONV §7): the API is
// the source of truth, and a second copy of it in the client is a second thing that can be wrong.

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 or 403 will not become a 200 by asking again, and retrying an expired session only
      // delays the sign-in screen. Amplify has already tried the refresh token by this point.
      retry: false,
      staleTime: 30_000,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </QueryClientProvider>
  );
}
